import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getNotificationCounts(idUser: string): Observable<any> {
    const url = `${this.apiUrl}/historicNotification/homeNotification/${idUser}/0`;
    return this.http.get(url).pipe(
      tap(response => {
        console.log('Notification counts response:', response);
      })
    );
  }

  updateNotificationStatus(notificationData: { idType: number, idStudent: number, nameType: string }): Observable<any> {
    const url = `${this.apiUrl}/historicNotification/updateHistoricNotification`;
    return this.http.post(url, notificationData);
  }

  /**
   * Show a notification message to the user
   * @param type 'success', 'error', 'warning', 'info'
   * @param message The message to display
   */
  showNotification(type: 'success' | 'error' | 'warning' | 'info', message: string): void {
    // For now, log to console. Can be enhanced with a toast/snackbar service later
    const timestamp = new Date().toLocaleTimeString();
    console.log(`[${timestamp}] [${type.toUpperCase()}]: ${message}`);
  }
}